import { resto, analytics, userService } from '@saucelabs/sl-util-axios';

import { TEAM_API_DEFAULT_PARAMS } from '../../constants';

/**
 * @param {string} username
 * @param {Object} params
 * @param {number} params.limit
 */
export function getOrganization(username, params = {}) {
  return resto.get(
    `/rest/v1.1/users/${username}/organization`,
    {
      params: { limit: 100, ...params },
    },
  );
}

export const getTeams = (params) => (
  userService.get('/v1/teams/', { params: { ...TEAM_API_DEFAULT_PARAMS, ...params } })
);

/**
 * @param {Object} params
 * @param {Array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getTrends(params) {
  return analytics.get('/trends/tests', { params });
}

/**
 * @param {Object} params
 * @param {Array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getAggregatedTestErrors(params) {
  return analytics.get('/trends/errors', { params });
}

/**
 * @param {Object} params
 * @param {Array} params.{string} - Filters are passed as a string key and value as an array
 */
export function getTestsByError(params) {
  return analytics.get('/tests', { params });
}
